import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=0c3d8d79"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=0c3d8d79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_@vue+compiler-sfc@_21fabc512e5cf77502f11efea17f021f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports